import GrillaJuicios from '../../moleculas/GrillaJuicios/GrillaJuicios'

function GrillaJuiciosContainer() {
  return (
    <div> 
      <GrillaJuicios/>
    </div>
  )
}

export default GrillaJuiciosContainer
